(function () {
  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  function qs(root, sel) {
    return (root || document).querySelector(sel);
  }

  function qsa(root, sel) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function buildTocJsonUrl(blogHandle, tag) {
    // tag должен быть без "#"
    return (
      "/blogs/" +
      encodeURIComponent(blogHandle) +
      "/tagged/" +
      encodeURIComponent(tag) +
      "?view=toc-json"
    );
  }

  function clearList(listEl) {
    while (listEl.firstChild) listEl.removeChild(listEl.firstChild);
  }

  function renderArticles(listEl, articles) {
    clearList(listEl);
    if (!articles || !articles.length) return;

    for (var i = 0; i < articles.length; i++) {
      var a = articles[i];
      if (!a || !a.url || !a.title) continue;

      var li = document.createElement("li");
      li.className = "blog-toc__item";

      var link = document.createElement("a");
      link.className = "blog-toc__link";
      link.href = a.url;
      link.textContent = a.title;

      li.appendChild(link);
      listEl.appendChild(li);
    }
  }

  function setActiveButton(buttons, activeBtn) {
    buttons.forEach(function (b) {
      b.classList.toggle("is-active", b === activeBtn);
      b.setAttribute("aria-current", b === activeBtn ? "true" : "false");
    });
  }

  function closeAll(clusters, buttons) {
    clusters.forEach(function (c) {
      c.hidden = true;
      c.classList.remove("is-open");
    });
    buttons.forEach(function (b) {
      b.classList.remove("is-active");
      b.setAttribute("aria-current", "false");
      b.setAttribute("aria-expanded", "false");
    });
  }

  function loadCluster(blogHandle, clusterEl) {
    // Если кластер уже грузили — не грузим повторно
    if (clusterEl.dataset.loaded === "1") {
      return Promise.resolve(true);
    }

    var tag = clusterEl.dataset.clusterTag || "";
    if (!tag) {
      clusterEl.dataset.loaded = "1";
      return Promise.resolve(true);
    }

    var listEl = qs(clusterEl, "[data-cluster-list]");
    var errorEl = qs(clusterEl, "[data-cluster-error]");

    if (errorEl) errorEl.hidden = true;

    // ВАЖНО: listEl может быть не найден — тогда просто ничего не рендерим
    var url = buildTocJsonUrl(blogHandle, tag);

    return fetch(url, { credentials: "same-origin" })
      .then(function (res) {
        if (!res.ok) throw new Error("HTTP " + res.status);
        return res.json();
      })
      .then(function (data) {
        var articles = (data && data.articles) ? data.articles : [];
        if (listEl) renderArticles(listEl, articles);
        clusterEl.dataset.loaded = "1";
        return true;
      })
      .catch(function (e) {
        console.error("[blog-toc] No articles yet:", url, e);
        if (errorEl) {
          errorEl.textContent = "No articles yet.";
          errorEl.hidden = false;
        }
        // даже если ошибка — пометим как loaded, чтобы не долбить сервер при каждом клике
        clusterEl.dataset.loaded = "1";
        return false;
      });
  }

  function openClusterById(root, id, opts) {
    opts = opts || {};
    var blogHandle = root.dataset.blogHandle || "";
    if (!blogHandle) return;

    var buttons = qsa(root, ".blog-toc__cluster-btn");
    var clusters = qsa(root, ".blog-toc__cluster");
    if (!buttons.length || !clusters.length) return;

    var targetCluster = document.getElementById(id);
    if (!targetCluster) return;

    var targetBtn = null;
    for (var i = 0; i < buttons.length; i++) {
      if (buttons[i].dataset.target === id) {
        targetBtn = buttons[i];
        break;
      }
    }

    var isOpening = targetCluster.hidden === true;

    // закрываем всё
    closeAll(clusters, buttons);

    // если кликнули по уже открытому — оставляем всё закрытым
    if (!isOpening) {
      if (opts.updateHash) {
        history.replaceState(null, "", window.location.pathname + window.location.search);
      }
      return;
    }

    // открываем нужный
    if (targetBtn) {
      targetBtn.classList.add("is-active");
      targetBtn.setAttribute("aria-current", "true");
      targetBtn.setAttribute("aria-expanded", "true");
      setActiveButton(buttons, targetBtn);
    }

    targetCluster.hidden = false;
    targetCluster.classList.add("is-open");

    loadCluster(blogHandle, targetCluster).then(function () {
      if (opts.updateHash) {
        history.replaceState(null, "", "#" + id);
      }
    });
  }

  function initOne(root) {
    var blogHandle = root.dataset.blogHandle || "";
    if (!blogHandle) return;

    var buttons = qsa(root, ".blog-toc__cluster-btn");
    var clusters = qsa(root, ".blog-toc__cluster");

    // если разметка не совпала — ничего не делаем
    if (!buttons.length || !clusters.length) return;

    // по умолчанию всё закрыто
    closeAll(clusters, buttons);

    // клики по кнопкам
    buttons.forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        var id = btn.dataset.target;
        if (!id) return;
        openClusterById(root, id, { updateHash: true });
      });
    });

    // если пришли с #cluster-...
    if (window.location.hash && window.location.hash.length > 1) {
      var idFromHash = window.location.hash.slice(1);
      // откроем только если такой кластер реально есть
      if (document.getElementById(idFromHash)) {
        openClusterById(root, idFromHash, { updateHash: false });
      }
    }
  }

  ready(function () {
    window.__BLOG_TOC_LOADED__ = true;
    var roots = qsa(document, ".blog-toc[data-blog-handle]");
    roots.forEach(initOne);
  });
})();
